import { createSelector } from 'reselect'
import { selectKnownMailboxes } from './selectKnownMailboxes'

export const selectRealMailboxes = createSelector(
  selectKnownMailboxes,
  knownMailboxes => knownMailboxes.filter(mailbox => mailbox.state !== 'demo')
)
